module.exports = Date.now || now

function now() {
    return new Date().getTime()
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/date-now/index.js
// module id = ../../../../date-now/index.js
// module chunks = vendor